import React from "react";
import MultiTextAdd from "@Components/Form/MultiTextAdd";
export default class Multi extends React.Component {
    render() {
        return (React.createElement(MultiTextAdd, { chat: true, values: this.props.values, onChange: this.props.change, separators: [",", " "], placeHolder: 'Press "," between inputs', format: this.props.validation }));
    }
}
